import client from './api-client';

export const serviceGetGestionImplicado = async (query) => {
    try {
        const response = await client.get(`getion-implicado?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetComboMonedas = async (query) => {
    try {
        const response = await client.getMonedas(`monedas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetPretensionesVigentes = async (query) => {
    try {
        const response = await client.get(`pretensiones/coberturas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetBancos = async (query) => {
    try {
        const response = await client.get(`bancos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetDetalle = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } 
    catch (error) {
        throw error;
    }
}

export const serviceGetCoberturaProvisiones = async(query) => {
    try {
        const response = await client.get(`pretensiones/coberturas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceCierreGestionDefenza = async(body) => {
    try {
        const response = await client.post('getion-implicado/cierre-defensa', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}

export const serviceGetHistorialAumentoConciliar = async (query) => {
    try {
        const response = await client.get(`getion-implicado/aumento-conciliar?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const servicePostSolicitudAumentoConciliar = async (body) => {
    try {
        const response = await client.post('getion-implicado/aumento-conciliar', body);
        return response.data;
    } catch (error) {
        throw error;
    }
}